import type { JSX } from 'react';
import React from 'react';

import type { IPartner } from '@feathr/blackbox';

import SelectOption from './SelectOption';
import type { ISelectOptionProps } from './SelectOptions.types';

import { contentWrapper } from './SelectOptions.css';

import noImg from 'images/no-img.png';

function PartnerOption<T extends IPartner>(props: Readonly<ISelectOptionProps<T>>): JSX.Element {
  return (
    <SelectOption {...props}>
      <div className={contentWrapper}>
        <div
          style={{
            marginRight: '10px',
            backgroundImage: `url("${props.data.logo || noImg}")`,
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            width: '36px',
            height: '36px',
            borderRadius: '4px',
          }}
        />
        <span>{props.data.name}</span>
      </div>
    </SelectOption>
  );
}

export default PartnerOption;
